// Central role-permission config.
// Edit this file to change UI permissions for the entire app.
//
// Used by `useCan()` (src/hooks/useCan.js) and by `ProtectedRoute`
// declarations in `src/routes/AppRoutes.jsx`.

import { ROLE } from "../constants/auth";

/**
 * For each capability, list the roles that are allowed.
 * Add a new capability here, then read it via `useCan()`.
 */
export const PERMISSIONS = Object.freeze({
  // --- Master / system data writes (CRUD)
  manageMasterData: [ROLE.ADMIN],          // bottles, bites, stock, etc.
  manageUsers:      [ROLE.ADMIN],
  manageNotifications: [ROLE.ADMIN],
  viewAuditLogs:    [ROLE.ADMIN],

  // --- Read-only / monitoring
  viewAdmin:        [ROLE.OWNER, ROLE.ADMIN],     // dashboards, reports, sales
  approveCorrection:[ROLE.OWNER, ROLE.ADMIN],
  exportReports:    [ROLE.OWNER, ROLE.ADMIN],
  monitorCashiers:  [ROLE.OWNER, ROLE.ADMIN],

  // --- Cashier operational scope
  operatePOS:       [ROLE.BAR_CASHIER],
  openCashSession:  [ROLE.BAR_CASHIER],
  requestCorrection:[ROLE.BAR_CASHIER],
});

/** Returns true when the given role is in the capability's allow-list. */
export const can = (capability, role) =>
  (PERMISSIONS[capability] || []).includes(role);
